var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-h-[--banner-height] tw-w-full tw-flex tw-items-center tw-justify-center tw-px-8",class:_vm.className({ color: _vm.color })},[_c('div',{staticClass:"tw-mx-auto"},[_vm._t("default")],2),(_vm.$slots.actions)?_c('span',{staticClass:"tw-flex tw-items-center tw-space-x-3"},[_vm._t("actions")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }